import { useMutation } from "@tanstack/react-query";
import { updateBulletin } from "../api/updateBulletin";
import { invalidateBulletinListQuery } from "../queries/useBulletinListQuery";
import { BulletinDataToUpdate } from "../types";

type Params = {
  bulletin: BulletinDataToUpdate;
  bulletinId: string;
};

export const useUpdateBulletinMutation = (onSuccess: () => void) => {
  return useMutation({
    mutationFn: async ({ bulletin, bulletinId }: Params) => {
      return await updateBulletin(bulletinId, bulletin);
    },
    onSuccess: () => {
      invalidateBulletinListQuery();
      onSuccess();
    },
    onError: (e) => console.error(e),
  });
};
